export const formatDateTime = (date: string | Date): string => {
  const dateObj = new Date(date);

  const time = dateObj.toLocaleTimeString('en-AU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  const dateStr = dateObj.toLocaleDateString('en-AU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return `${time} ${dateStr}`;
};
